<template>
  <card-container-layout>
    <div class="mb-3">
      <default-card-title-component
        text="INTEREST & ENGAGEMENT"
      ></default-card-title-component>
    </div>
    <div class="d-flex align-items-center justify-content-between">
      <div style="flex: 1;">
        <click-stat-item :metric="clickMetric"></click-stat-item>
        <card-info-text
          text="Total number of clicks on your ad"
        ></card-info-text>
      </div>
      <vertical-separator height="75px" gap="28px"></vertical-separator>
      <div style="flex: 1;">
        <social-ad-engagement-stat-item
          :metric="socialAdMetric"
        ></social-ad-engagement-stat-item>
        <card-info-text
          text="Total number of likes, shares & comments"
        ></card-info-text>
      </div>
    </div>
  </card-container-layout>
</template>
<script>
import DefaultCardTitleComponent from '../Common/DefaultCardTitleComponent.vue';
import CardInfoText from '../Common/CardInfoText.vue';
import CardContainerLayout from '../Common/CardContainerLayout.vue';
import SocialAdEngagementStatItem from '../StatItems/SocialAdEngagementStatItem.vue';
import VerticalSeparator from '../Common/VerticalSeparator.vue';
import ClickStatItem from '../StatItems/ClickStatItem.vue';

export default {
  props: {
    clickMetric: [String, Number],
    socialAdMetric: [String, Number],
  },
  components: {
    DefaultCardTitleComponent,
    CardInfoText,
    CardContainerLayout,
    SocialAdEngagementStatItem,
    ClickStatItem,
    VerticalSeparator,
  },
};
</script>
